var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-loader-section"},[_c('div',{staticClass:"modal-loader"},[_c('LoaderSmb'),_vm._t("text",function(){return [_vm._v("Chargement en cours")]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }